import {get} from 'lodash-es';
import {takeLatest, put} from 'redux-saga/effects';

import {
  requestRosterSyncInfo,
  fetchEventRecords,
  requestDistrictConfiguration,
} from 'modulesV2/actions';
import * as types from 'modulesV2/constants';
import {WELCOME_BACK_EVENT_NAME} from 'modulesV2/constants/onboardingConstants';

import {requestTeacherSubjects} from '../../routes/Home/modules/homeDucks';

/**
 * @returns {Generator}
 */
function * initializeWelcomeBack(action) {
  const teacherId = get(action, 'user.teacher.id');
  // Only teachers can be welcomed back at this point.
  if (teacherId) {
    // Request all the data required to make a decision whether or not
    // to show welcome back message.
    yield put(requestTeacherSubjects(teacherId));
    yield put(requestRosterSyncInfo());
    yield put(fetchEventRecords(WELCOME_BACK_EVENT_NAME));
    yield put(requestDistrictConfiguration());
  }
}

// --- Watchers ---- //
export function * watchInitializeWelcomeBack() {
  yield takeLatest(types.INITIALIZE_WELCOME_BACK, initializeWelcomeBack);
}
